import React, { useState, useEffect } from 'react';
import { CourseSidebar } from './course-sidebar';
import { CourseContent } from './course-content';
import { t } from 'i18next';
import { i18n } from '@/app/components/i18n/i18n';
import { Dashboard } from '@/layouts/dashboard';

export function CourseCreate(props) {
  const { step } = props;

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  const steps = [
    {
      id: 0,
      route: 'sobre',
      text: t('courses.routeAbout')
    },
    {
      id: 1,
      route: 'imagem',
      text: t('courses.routeImage')
    }
  ];

  function getStep() {
    switch (step) {
      case 'sobre':
        setCurrentStep(0);
        break;
      case 'imagem':
        setCurrentStep(1);
        break;
      default:
        setCurrentStep(0);
        break;
    }
  }

  useEffect(() => getStep(), [step]);

  return (
    <Dashboard>
      <CourseSidebar
        currentStep={currentStep}
        steps={steps}
      />

      <CourseContent
        step={step}
        steps={steps}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </Dashboard>
  );
}
